import React from "react";
import { useParams } from "react-router-dom";
import BrandNav from "../../components/BrandNav";

export default function RoboticsMeetDetail() {
  const { slug } = useParams();
  return (
    <>
      <BrandNav />
      <main className="ftg-page">
        <h1>Team Member: {slug}</h1>
      </main>
    </>
  );
}
